var chapterQuizSettings = function (settings,chapter_id) {
    var str = '<div class="row"><div class="col-md-12 col-lg-12 col-sm-12"><table class="table chapter-table"><tr><th>Chapter</th><th>Number</th><th>Maximum</th></tr>';

    for ( var i = 0; i < settings.chapters.length ; i++ ) {
        var chapter = settings.chapters[i];
        //console.log(chapter);
        //console.log(chapter_id);
        if (chapter.id === parseInt(chapter_id) ) {
            str += '<tr>' +
                '<td><label for="chapter_'+ chapter.id +'">'+ chapter.name+'</label></td>' +
                '<td><input type="text" class="chapter-count" id="num_'+ chapter.id +'" value="'+ chapter.count +'" numMax="'+ chapter.count+'"></td>' +
                '<td>'+ chapter.count +'</td>' +
                '</tr>';
        }

    }
    str +='</table></div></div>';
    var table = $.parseHTML(str);





    $(table).find('.chapter-count').on('change',function() {
        var val = parseInt($(this).val());
        var max = parseInt($(this).attr('numMax'));
        if ( parseInt($(this).val()) > parseInt($(this).attr('numMax')) ) {
            $(this).val( $(this).attr('numMax'));
        }
    });

    return table;
}

module.exports = chapterQuizSettings;


//////////////////
// WEBPACK FOOTER
// ./src/chapter_quiz_settings.js
// module id = 296
// module chunks = 0